// extracted by mini-css-extract-plugin
module.exports = {"form":"NewTeacherForm_form__273O6"};